// src/eventBus.js
import Vue from "vue";
export const EventBus = new Vue();

export function showSnackbar (data) {
    EventBus.$emit('showSnackbar', data)
}
